import React from 'react';
import PropTypes from 'prop-types';

const Notification = ({ notificationItem, lastOpenedAt, fetchedAt }) => {
  const { path, copy, updated_at: updatedAt } = notificationItem;
  const unseen = updatedAt > lastOpenedAt;
  const timeInMinutes = (fetchedAt - updatedAt) / 60;
  let timeAgo = 'Now';

  // 2+ days
  if (timeInMinutes > (2 * 24 * 60)) {
    timeAgo = `${Math.floor(timeInMinutes / 60 / 24)} days ago`;
  } else if (timeInMinutes > (24 * 60)) {
    timeAgo = '1 day ago';
  } else if (timeInMinutes > (2 * 60)) {
    timeAgo = `${Math.floor(timeInMinutes / 60)} hours ago`;
  } else if (timeInMinutes > 60) {
    timeAgo = '1 hour ago';
  } else if (timeInMinutes > 2) {
    timeAgo = `${Math.floor(timeInMinutes)} minutes ago`;
  } else if (timeInMinutes > 1) {
    timeAgo = '1 minute ago';
  }

  const dateTitle = new Date(updatedAt * 1000).toLocaleString();

  return (
    <li className="Notification-list-item">
      <a href={path} className="Notification">
        <div>
          <div dangerouslySetInnerHTML={{ __html: copy }} />
          <div className="Notification-time" title={dateTitle}>
            {timeAgo}
          </div>
        </div>
        {unseen && <div className="Notification-dot" />}
      </a>
    </li>
  );
};

Notification.propTypes = {
  notificationItem: PropTypes.shape({
    path: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    updated_at: PropTypes.number.isRequired
  }).isRequired,
  lastOpenedAt: PropTypes.number.isRequired,
  fetchedAt: PropTypes.number.isRequired
};

export default Notification;
